module.exports = __webpack_public_path__ + "static/media/logo.0117105e.webp";